
import React, { useEffect } from "react";
import { C, RF } from "../utils/api";

export default function Averias({averias, updateAv, user, loadAv}) {
  useEffect(()=>{loadAv();},[]);
  return (
    <div style={{height:"100%",overflowY:"auto",padding:"1rem"}}>
      <h2 style={{fontSize:16,fontWeight:600,margin:"0 0 14px"}}>Averias abiertas ({averias.length})</h2>
      {averias.length===0 && <p style={{color:C.muted,textAlign:"center",padding:"2rem 0"}}>Sin averias activas</p>}
      {averias.map(a=>(
        <div key={a.id} style={{background:C.white,borderRadius:10,padding:"12px",marginBottom:10,border:"2px solid #FCA5A5"}}>
          <p style={{margin:"0 0 4px",fontWeight:600,fontSize:14}}>{a.titulo}</p>
          <p style={{margin:"0 0 4px",fontSize:12,color:C.muted}}>{(a.equipo_tipo||"").toUpperCase()} - {a.reportado_por_nombre}</p>
          <p style={{margin:"0 0 8px",fontSize:12}}>{a.descripcion}</p>
          <div style={{display:"flex",gap:6}}>
            {RF.includes(user.rol) && <button onClick={()=>updateAv(a.id,"en_proceso")} style={{padding:"4px 10px",background:"#F59E0B",color:"#fff",border:"none",borderRadius:6,fontSize:11,cursor:"pointer"}}>En proceso</button>}
            {RF.includes(user.rol) && <button onClick={()=>updateAv(a.id,"resuelta")} style={{padding:"4px 10px",background:"#10B981",color:"#fff",border:"none",borderRadius:6,fontSize:11,cursor:"pointer"}}>Resolver</button>}
          </div>
        </div>
      ))}
    </div>
  );
}
